import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["analyticsName", "onAnalyticsModalOpen", "onAnalyticsModalClose", "children", "heading", "header", "footer", "customFooter"];
import AkModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import * as React from 'react';
export default class ModalDialog extends React.Component {
  componentDidMount() {
    this.props.onAnalyticsModalOpen(this.props.analyticsName);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.analyticsName !== this.props.analyticsName) {
      this.props.onAnalyticsModalClose(prevProps.analyticsName);
      this.props.onAnalyticsModalOpen(this.props.analyticsName);
    }
  }
  componentWillUnmount() {
    this.props.onAnalyticsModalClose(this.props.analyticsName);
  }
  render() {
    const _this$props = this.props,
      {
        analyticsName,
        onAnalyticsModalOpen,
        onAnalyticsModalClose,
        children,
        heading,
        header,
        footer,
        customFooter
      } = _this$props,
      modalProps = _objectWithoutProperties(_this$props, _excluded);
    return /*#__PURE__*/React.createElement(AkModalDialog, modalProps, heading && /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, heading)), header && /*#__PURE__*/React.createElement(ModalHeader, null, header), children && /*#__PURE__*/React.createElement(ModalBody, null, children), footer && /*#__PURE__*/React.createElement(ModalFooter, null, footer), customFooter && customFooter);
  }
}